import { MobiDocument } from './MobiDocument';

export class EnseignantScolaireDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private nom: string;
    private prenom: string;
    private civilite_id: number;
    private obsolete : boolean;

    //Attributs for Vuejs
    private displayName: string;


    public constructor(instit: any) {
        super()
        this._id = instit._id;
        this._rev = instit._rev;
        this.id = instit.id;
        this.nom = instit.nom;
        this.prenom = instit.prenom;
        this.civilite_id = instit.civilite_id;
        this.displayName = instit.nom + " " + instit.prenom;
        this.obsolete = instit.obsolete;

    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getNom(): string {
        return this.nom;
    }

    public setNom(nom: string): void {
        this.nom = nom;
    }

    public getPrenom(): string {
        return this.prenom;
    }

    public setPrenom(prenom: string): void {
        this.prenom = prenom;
    }

    public getCivilite_id(): number {
        return this.civilite_id;
    }

    public setCivilite_id(civilite_id: number): void {
        this.civilite_id = civilite_id;
    }
    
    public getDisplayName(): string {
        return this.displayName;
    }

    public setDisplayName(displayName: string): void {
        this.displayName = displayName;
    }

    public isObsolete(): boolean {
        return this.obsolete;
    }

    public setObsolete(obsolete: boolean): void {
        this.obsolete = obsolete;
    }

}